<template>
  <div class="form-missing grid">
    <div class="col xs-span l6">
      <div class="form-missing__content">
        <p
          class="text-heading-l text-heading-2xl-desktop"
          v-text="missingTitle"
        />

        <p
          class="text-body-s-regular"
          v-text="missingText"
        />
      </div>

      <btn
        :label="$string('vehicle_finder.cta_labels.search_again')"
        modes="light"
        modifiers="secondary center"
        @click="handleSearchAgain"
      />
    </div>

    <div
      v-if="vehicle"
      class="col xs-span l6"
    >
      <garage-hero-banner
        :form-id="formId"
        template="missing"
        :vehicle="vehicle"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Missing manual form (vehicle-finder-form)
 * -----------------------------------------------------------------------------
 * Missing manual component shown when no results are returned for vehicle.
 *
 * @param {String} [formId] - Unique ID for missing form.
 * @param {Object} vehicle - Vehicle to show.
 *
 */
import Btn from '~global/btn/btn'
import GarageHeroBanner from '~async/garage-hero-banner/garage-hero-banner'

import { validateVehicle } from '~/helpers/garage'

export default {
  name: 'FormMissing',

  components: {
    Btn,
    GarageHeroBanner,
  },

  props: {
    formId: {
      type: String,
      default: '',
    },
    vehicle: {
      type: [Boolean, Object],
      default: false,
      required: true,
      validator: validateVehicle,
    },
  },

  emits: {
    'search-again': () => true,
  },

  computed: {

    /**
     * Compute missing manual text.
     * @returns {String}
     */
    missingText() {
      return this.vehicle
        ? this.$string('vehicle_finder.missing.text')
        : this.$string('vehicle_finder.missing_product.text')
    },

    /**
     * Compute missing manual title.
     * @returns {String}
     */
    missingTitle() {
      return this.vehicle
        ? this.$string('vehicle_finder.missing.title')
        : this.$string('vehicle_finder.missing_product.title')
    },
  },

  methods: {

    /**
     * Handle search again.
     */
    handleSearchAgain() {
      this.$emit('search-again')
    },
  },
}
</script>

<style lang="scss">
@import './form-missing';
</style>
